// Section 3 and 23: land multipliers on crops, forage, water table and winter severity.
import { defineContributor } from '../../core/registry';
import { mod } from '../../core/modifiers';

export const landContributor = defineContributor({
  slot: 'land',
  id: 'land:core',
  targets: ['output', 'demand'],
  modifiers(ctx, target) {
    const land = ctx.state.options.land;
    const source = `land:${land}`;
    if (target.kind === 'demand') {
      if (target.resource !== 'warmth' || ctx.season.season !== 'winter') return [];
      return [mod.mul(source, ctx.cfg.land.winterSeverity[land], 'winter severity')];
    }
    if (target.kind !== 'output') return [];
    switch (target.jobId) {
      case 'farmer':
        return [mod.mul(source, ctx.cfg.land.crops[land], 'crops')];
      case 'forager':
        return [mod.mul(source, ctx.cfg.land.forage[land], 'forage')];
      case 'water-carrier':
        return [mod.mul(source, ctx.cfg.land.waterTable[land], 'water table')];
      default:
        return [];
    }
  },
});
